import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=492cc648&scoped=true&"
import script from "./order.ts?vue&type=script&lang=ts&"
export * from "./order.ts?vue&type=script&lang=ts&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=492cc648&prod&lang=scss&"
import style1 from "./Orders.vue?vue&type=style&index=1&id=492cc648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492cc648",
  null
  
)

export default component.exports